<app-global-header></app-global-header>
<main class="max-w-screen-xl mx-auto p-4 sm:p-6 lg:p-6 lg:p-8">
  <router-outlet></router-outlet>
</main>
<app-global-footer></app-global-footer>
